import { graphql } from 'react-apollo';
import { AllPromoCodes } from '../../queries/AllPromoCodes';

const createOptions = serverResponse =>
  (serverResponse &&
    serverResponse.map(({ id, code, percentage }) => ({
      key: id,
      value: id,
      text: `${code} ${percentage}%`
    }))) ||
  [];

const withPromoCodeOptions = graphql(AllPromoCodes, {
  skip: ({ affiliateId }) => !affiliateId,
  options: ({ affiliateId }) => ({
    variables: {
      filter: {
        affiliateId,
        active: true
      }
    }
  }),
  props: ({ data: { allPromoCodes, loading, error }, ownProps }) => {
    const promoCodesOptions = allPromoCodes
      ? [
          { key: 'empty', value: null, text: 'none' },
          ...createOptions(allPromoCodes)
        ]
      : [];
    const { id, code, percentage } = ownProps.currentPromoCode || {};
    const currentPromoCodeObj = id
      ? {
          key: id,
          value: id,
          text: `${code} ${percentage}%`
        }
      : null;
    if (!promoCodesOptions) return null;
    const currentPromoCodeIncluded = promoCodesOptions.some(
      ({ value }) => value === id
    );

    const extendedPromoCodesOptions =
      currentPromoCodeObj && !currentPromoCodeIncluded
        ? [currentPromoCodeObj, ...promoCodesOptions]
        : promoCodesOptions;
    return {
      error,
      loading,
      promoCodesOptions: extendedPromoCodesOptions
    };
  }
});

export default withPromoCodeOptions;



// WEBPACK FOOTER //
// ./src/component/HOC/withPromoCodeOptions.js